module.exports = __webpack_public_path__ + "img/how-to-navigate-5.32ec363a.jpg";